import { get } from '@services/local-storage-service'
import { useHistory } from 'react-router'
import React, { useEffect, useState } from 'react'
import { AUTHED_INFOR_LOCAL_STORAGE } from '@const/auth'
import { useSelector } from 'react-redux'
import roleConst from '@const/adminRoles'

export function withAuth<T> (
  WrappedComponent: React.ComponentType<T>,
  acceptedRoles: string[] = [roleConst.SuperAdmin]
) {
  // Try to create a nice displayName for React Dev Tools.
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  // Creating the inner component. The calculated Props type here is the where the magic happens.
  const ComponentWithAuthenticated = (props: T) => {
    const [auth, setAuth] = useState<TAuthDetail.State['informationAuthed']>()
    const router = useHistory()

    useEffect(() => {
      const authedInfor = get(AUTHED_INFOR_LOCAL_STORAGE) as TAuthDetail.State['informationAuthed']
      if (authedInfor) {
        setAuth(authedInfor)
        return
      }
      // error('禁断')
      router.push(`/login?fallBack=${router.location.pathname}${router.location.search}`)
    }, [router])

    const { roles } = useSelector(state => state.auth.user)
    let granted = false
    roles.forEach(role => {
      if (acceptedRoles.includes(role) || role === roleConst.SuperAdmin) {
        granted = true
      }
    })

    if (auth && granted) {
      return <WrappedComponent auth={auth} {...props} />
    }

    return null
  }

  ComponentWithAuthenticated.displayName = `withAuth(${displayName})`

  return ComponentWithAuthenticated
}
